// extracted by mini-css-extract-plugin
module.exports = {"selections-wrap":"SelectionsSection_selections-wrap__rpqG_"};